import React, { useEffect, useState } from 'react';
import NavBar from "../../Componants/NavBar";
import { useNavigate } from "react-router-dom";
import CardLage from "../../Componants/CardLage";
import TableParticular from "../../Componants/Particular/TableParticular";
import { Ajax } from "../../Service/ajax";
import { GridLoader } from "react-spinners";
import AlertSuccess from "../../Componants/AlertSuccess";
import Footer from "../../Componants/Footer";
import {convertDate} from "../../config/AppConfig";
import { useMediaQuery } from 'react-responsive';
import Swal from "sweetalert2";
import SubscriptionSection from "../../Componants/SubscriptionSection";
import {security} from "../../env/Environment";
import EvaluationSection from "../../Componants/EvaluationSection";
export default function InvitedView(){
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const [loading, setLoading] = useState(false);
    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                        <div className="layout-page">
                            <nav className="navbar navbar-example navbar-expand-lg bg-light layout-navbar-fixed">
                                <div className="container-fluid">
                                    <a type={"button"} className="display-7 text-black fw-bolder" onClick={()=>navigate("/")}>
                                        <img src={require("../../assets/img/illustrations/Netikash subscribe-2.png")} alt="Netiaksh Logo" className="mb-3" style={{width:150}}/>
                                    </a>
                                </div>
                            </nav>
                            <div className="content-wrapper">
                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <div className="col-md-12 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                                            <i className="bx bx-group mb-3" style={{ fontSize: "6rem", color: "#eccd7e" }}></i>
                                            <h2 className="text-center mb-3">
                                                Invitation à rejoindre une équipe
                                            </h2>
                                            <p className="text-center mb-4">
                                                Vous avez été invité à rejoindre une équipe pour collaborer ensemble sur des projets. Cliquez sur l'un des boutons ci-dessous pour accepter ou refuser l'invitation.
                                            </p>
                                            <div className="d-flex justify-content-center gap-3">
                                                <button className="btn btn-netikash" >
                                                    {"Accepter l'invitation"}
                                                </button>
                                                <button className="btn btn-danger" >
                                                    {"Refuser l'invitation"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-backdrop fade"></div>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
